// eslint-disable-next-line @typescript-eslint/no-empty-function
export default async function asyncNoop(): Promise<void> {}
